import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TwInspeccionCamViewModel, TwInspeccionUiCamViewModel } from './inspeccion.types';

@Injectable()
export class InspeccionUiService {
    private inspeccionUiEndpoint = this.baseUrl + 'api/campanias/inspeccioncam/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    get(id: number): Observable<TwInspeccionCamViewModel> {
        return this.http.get<TwInspeccionCamViewModel>(this.inspeccionUiEndpoint + id);
    }

    getListByUI(idUI: number): Observable<TwInspeccionCamViewModel[]> {
        return this.http.get<TwInspeccionCamViewModel[]>(this.inspeccionUiEndpoint + 'list/' + idUI);
    }

    insertOrUpdateUI(inspeccion: TwInspeccionUiCamViewModel): Observable<any> {
        if (Object.prototype.hasOwnProperty.call(inspeccion, 'NombreInspeccion')) {
            Reflect.deleteProperty(inspeccion, 'NombreInspeccion');
        }
        if (!inspeccion.Id) {
            inspeccion.Id = 0;
            return this.http.post<TwInspeccionUiCamViewModel>(this.inspeccionUiEndpoint, inspeccion);
        } else {
            return this.http.put<TwInspeccionUiCamViewModel>(this.inspeccionUiEndpoint, inspeccion);
        }
    }

    delete(id: number): Observable<any> {
        return this.http.delete<any>(this.inspeccionUiEndpoint + id);
    }

    testTransiciones(): Observable<HttpResponse<Blob>> {
        return this.http.post(this.inspeccionUiEndpoint + 'test-transiciones/', null, { observe: 'response', responseType: 'blob' });
    }

    testTransicionesPreinscrita(): Observable<any> {
        return this.http.post(this.inspeccionUiEndpoint + 'test-transiciones-preinscrita/', null);
    }
}
